var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 13.5h-7.5c-1.656855 0-3-1.3431452-3-3v-6c0-.8284275.6715725-1.5 1.5-1.5h10.5c.8284274 0 1.5.6715725 1.5 1.5v6c0 1.6568551-1.3431451 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.75000013 3v-1.5c0-.8284275.6715725-1.5 1.5-1.5h3c.82842744 0 1.5.6715725 1.5 1.5v1.5"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.25,
    rx: 0.27614,
    width: 3,
    x: 5.25,
    y: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.25000013 7.12499977h2.62499997-.0000001c1.44975 0 2.625-1.17525 2.625-2.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.25000013 7.12499977h-2.625-.00000011c-1.44975 0-2.625-1.17525-2.625-2.625"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.d90f66eb7961c0ac2022a732c8bdcfda.svg";
export { ForwardRef as ReactComponent };